// Assets
import { ReactComponent as ErrorIllustration } from '../../assets/error-illustration.svg';
import { useErrorBoundary } from '../../contexts/error-boundary.context';
import Button from '../button';

import './error-fallback.scss';

interface ErrorFallbackProps {}

const ErrorFallback: React.FunctionComponent<ErrorFallbackProps> = () => {
	const { setIsError } = useErrorBoundary();

	function onClick() {
		setIsError(false);
	}

	return (
		<div className="error-fallback">
			<ErrorIllustration className="error-fallback__illustration" />
			<h1 className="error-fallback__title">Uh oh uh...</h1>
			<p className="error-fallback__description">
				You have experienced an error that we are working hard to fix. Please try again in a moment.
			</p>
			<Button variant="outline" danger style={{ textTransform: 'uppercase' }} onClick={onClick}>
				Okay
			</Button>
		</div>
	);
};

export default ErrorFallback;
